import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { getStoredLocale, setStoredLocale, translate, translateCategory } from './messages';

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [locale, setLocaleState] = useState(getStoredLocale);

  useEffect(() => {
    document.documentElement.lang = locale === 'zh' ? 'zh-CN' : 'en';
  }, [locale]);

  const setLocale = useCallback((next) => {
    setStoredLocale(next);
    setLocaleState(next);
  }, []);

  const t = useCallback((path, vars) => translate(locale, path, vars), [locale]);

  const tc = useCallback((category) => translateCategory(locale, category), [locale]);

  const value = useMemo(
    () => ({
      locale,
      setLocale,
      t,
      tc,
    }),
    [locale, setLocale, t, tc]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error('useI18n must be used within I18nProvider');
  }
  return ctx;
}
